
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manga/[id]",
      function () {
        return require("private-next-pages/manga/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manga/[id]"])
      });
    }
  